export default __webpack_public_path__ + "static/fonts/DidotHTF-Bold.56a6424.woff";